import Vue from 'vue';
import Router from 'vue-router';
import AccessGroupComponent from "./components/Endpoints/AccessGroup.vue";
import AccessGroupsListComponent from "./components/Endpoints/AccessGroupsList.vue";
import AppConfigsListComponent from "./components/Systems/OrgLevelAppConfigs.vue";
import AuditHistoryCust from "./components/App/AuditHistoryCust.vue";
import CollectorLogs from "./components/Logs/CollectorLogs.vue";
import CollectorDrivers from "./components/Collector/Drivers.vue";
import CollectorMetrics from "./components/Logs/CollectorMetrics.vue";
import GettingStarted from "./components/Collector/GettingStarted.vue";
import COMainComponent from "./components/CrossOrg/CrossOrgMain.vue";
import COAppConfigsListComponent from "./components/CrossOrg/COAppConfigsList.vue";
import COEndpointsListComponent from "./components/CrossOrg/COEndpointsList.vue";
import COSystemsListComponent from "./components/CrossOrg/COSystemsList.vue";
import COUsersListComponent from "./components/CrossOrg/COUsersList.vue";
import COWorkerSessionsListComponent from "./components/CrossOrg/COWorkerSessionsList.vue";
import DatasetView from "../../vueComponents/datasetView/src/datasetView.vue";
import EndpointsListComponent from "./components/Endpoints/EndpointsList.vue";
import EntitlementsView from "./components/Entitlements/EntitlementsView.vue";
import HomePage from './components/App/HomePage.vue';
import LoginService from '../../services/login.service';
import OrgEditComponent from "./components/CrossOrg/OrgEdit.vue";
import OrgApproveComponent from "./components/CrossOrg/OrgApprove.vue";
import OrgsListComponent from "./components/CrossOrg/OrganizationsList.vue";
import MainComponent from "./components/App/Main.vue";
import NewSystemComponent from "./components/Systems/NewSystem.vue";
import SystemAdminComponent from "./components/Systems/SystemAdmin.vue";
import SystemConfigComponent from "./components/Systems/SystemConfig.vue";
import SystemsListComponent from "./components/Systems/SystemsList.vue";
import UpgradeCollector from "./components/Collector/UpgradeCollector.vue";
import UsersListComponent from "./components/Users/UsersList.vue";
import AccountSettingsMainComponent from "./components/AccountSettings/AccountSettingsMain.vue";
import { store } from './store/index';
import DataProvider from "../../app/data-framework/data-provider";
import _ from 'lodash';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: "/admin",
            name: "main",
            component: MainComponent,
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    path: 'welcome',
                    name: 'welcomepage',
                    component: HomePage,
                    alias: 'welcome/tabid/*'
                },
                {
                    path: 'gettingStarted',
                    name: 'gettingStarted',
                    component: GettingStarted
                },
                {
                    path: 'upgradeCollector',
                    name: 'upgradeCollector',
                    component: UpgradeCollector
                },
                {
                    path: 'auditHistory',
                    name: 'auditHistory',
                    component: AuditHistoryCust
                },
                {
                    path: 'infrastructure/list',
                    name: 'systemslist',
                    component: SystemsListComponent
                },
                {
                    path: 'infrastructure/new',
                    name: 'newsystem',
                    component: NewSystemComponent,
                    meta: {
                        disableOrgSelection: true
                    }
                },
                {
                    path: 'infrastructure/config',
                    name: 'newsysconfig',
                    component: SystemConfigComponent,
                    meta: {
                        disableOrgSelection: true
                    }
                },
                {
                    path: 'infrastructure/:id',
                    name: 'system',
                    component: SystemAdminComponent,
                    children: [
                        {
                            path: 'config',
                            name: 'sysconfig',
                            component: SystemConfigComponent,
                            meta: {
                                disableOrgSelection: true
                            }
                        }
                    ]
                },
                {
                    path: 'endpoints/list',
                    name: 'endpointsList',
                    component: EndpointsListComponent
                },
                {
                    path: 'endpoints/monitorGroupsList',
                    name: 'monitorGroupsList',
                    component: AccessGroupsListComponent
                },
                {
                    path: 'endpoints/monitoringGroup/:id',
                    name: 'monitoringGroupConfig',
                    component: AccessGroupComponent,
                    meta: {
                        disableOrgSelection: true
                    }
                },
                {
                    path: 'collectors/logs',
                    name: 'collectorLogs',
                    component: CollectorLogs
                },
                {
                    path: 'collectors/metrics',
                    name: 'collectorMetrics',
                    component: CollectorMetrics
                },
                {
                    path: 'collectors/drivers',
                    name: 'collectorDrivers',
                    component: CollectorDrivers
                },
                {
                    path: 'datasets/:datasetName',
                    name: 'dataset',
                    component: DatasetView,
                    props: route => ({
                        routeParams: {
                            appId: 'admin',
                            datasetName: route.params.datasetName,
                            hasDateRangePicker: route.params.datasetName === 'all-documents' || route.params.datasetName === 'documents', // todo list all
                            liveModeStatus: route.params.datasetName === 'all-documents' || route.params.datasetName === 'documents' ? false : undefined,
                            pageId: route.params.datasetName,
                            title: _.startCase(route.params.datasetName),
                            watchOrgContext: route.params.datasetName !== 'last-documents' && route.params.datasetName !== 'all-documents',
                            viewId: route.params.datasetName,
                        }
                    })
                },
                {
                    path: 'users/list',
                    name: 'userslist',
                    component: UsersListComponent
                },
                {
                    path: 'configs',
                    name: 'appConfigs',
                    component: AppConfigsListComponent
                },
                {
                    path: 'entitlements',
                    name: 'entitlements',
                    component: EntitlementsView
                },
                {
                    path: 'co/endpoints/list',
                    name: 'coendpointslist',
                    component: COEndpointsListComponent
                },
                {
                    path: 'co/infrastructure/list',
                    name: 'coinfrastructurelist',
                    component: COSystemsListComponent
                },
                {
                    path: 'co/users/list',
                    name: 'couserslist',
                    component: COUsersListComponent
                },
                {
                    path: 'co/configs/list',
                    name: 'coappconfigslist',
                    component: COAppConfigsListComponent
                },
                {
                    path: 'co/sessions/list',
                    name: 'coworkersessionslist',
                    component: COWorkerSessionsListComponent
                },
                {
                    path: 'co/organizations/list',
                    name: 'organizationslist',
                    component: OrgsListComponent
                },
                {
                    path: 'co/organizations/:id',
                    name: 'orgEdit',
                    component: OrgEditComponent,
                    meta: {
                        disableOrgSelection: true
                    }
                },
                {
                    path: 'co/orgApprovals/approve/:email/:name',
                    name: 'orgApprove',
                    component: OrgApproveComponent,
                    meta: {
                        disableOrgSelection: true
                    }
                },
                {
                    path: 'superUser',
                    name: 'crossOrg',
                    component: COMainComponent
                },
                {
                    path: 'co/:tab',
                    name: 'crossOrgTab',
                    component: COMainComponent
                },
                {
                    path: 'settings',
                    name: 'accountSettings',
                    component: AccountSettingsMainComponent
                }
            ]
        }
    ]
});

router.beforeEach(async (to, from, next) => {
    // let loggedIn = store.state.user.isLoggedIn; // UI-2659 auth handled by knockout for now, just check privileges
    const user = LoginService.userObject;
    if (user  && !user.isSu() && !user.isUserAdmin() && !user.isUserPro() && !user.isSuPro()) {
        if (to.path.indexOf('admin') > -1) {
            alert('This user does not have the required privileges. Please contact your administrator.');
            window.location.replace(DataProvider.getInstance().getDefaultLocation());
        }
        return false;
    }
    if ((to.path === '/' || to.path === '/admin') && !LoginService.isLoggedOut) {
        next({
            name: 'welcomepage',
            replace: true
        });
    } else if (to.path.indexOf('admin') > -1) {

        const isSUMenuItem = store.getters['menus/isSUMenuItem']((to.params ? to.params.datasetName : false) || to.name);

        if (isSUMenuItem && !user.isSu() && !user.isSuPro()) {
            next({
                name: 'welcomepage',
                replace: true
            });
        } else {
            next()
        }
    }
});

router.afterEach((to, from) => {
    var objActivity = {
        action: 'navigation',
        appId: 'cpm-admin',
        view: to.name,
        tab: '',
        url: window.location.href,
        source: to.path,
        data: '',
    }
    store.dispatch('status/logActivity',objActivity)
});

export default router;
